import {
  Alert,
  Box,
  Button,
  CircularProgress,
  FormControl,
  Grid,
  IconButton,
  InputAdornment,
  InputLabel,
  MenuItem,
  Select,
  Slider,
  Snackbar,
  Table,
  TableBody,
  TableCell,
  TableRow,
  TextField,
  Typography
} from "@mui/material";
import axios from "axios";
import React, { useEffect, useRef, useState } from "react";
import ReusableModal from "./Model";
import { auth } from "../../firebase";
import { AttachFile, Close, PictureAsPdf } from "@mui/icons-material";
import AdminView from "./FertilizerRecommendation/AdminView";
import UserView from "./FertilizerRecommendation/UserView";
import ExpertView from "./FertilizerRecommendation/ExpertView";


const recommendation = () => {
  const zones = [
    "Western Himalayas (J & K, H.P.)",
    "Uttarakhand",
    "Eastern Himalaya (Assam,  W.B., NE  states)",
    "Lower Gangatic Plain  (W.B.)",
    "Middle Gangetic Plain  (Eastern  U.P.)",
    "Bihar",
    "Upper Gangetic  Plain  (Western  U.P.)",
    "Trans Gangetic Plain (Punjab)",
    "Haryana",
    "Eastern  Plateau  &  Hills",
    "Chhatisgarh",
    "Jharkhand",
    "Eastern  Maharashtra (Bhandera region)\n& part of Orissa",
    "Central Plateau & Hills",
    "Madhya  Pradesh",
    "U.P. (Bundel Khand)",
    "Maharashtra",
    "Western Plateau (Maharashtra  and Southern  M.P.)",
    "Southern  Plateau",
    "Andhra  Pradesh",
    "Karnataka",
    "Tamil Nadu",
    "East  Coast  Plains  &  Hills",
    "Orissa",
    "West  Coast  Plains &  Ghats",
    "Kerala",
    "Maharashtra  (Konkan)",
    "Gujarat  Plains  &  Hills",
    "Northern Gujarat",
    "Southern  Gujarat",
    "Western Dry Region (Rajasthan)",
    "Island region (Andaman & Nicobar)"
  ];
  const seasons = ["Spring", "Summer", "Autumn", "Winter"];

  const [val, setVal] = React.useState({
    temperature: 25,
    humidity: 50,
    nitrogen: 50,
    potassium: 50,
    phosphorus: 50,
    moisture: 20,
    croptype: "Barley",
    soiltype: "Black",
    modeltype: "v2"
  });
  const [predicted, setPredictedData] = useState("");
  const [predictedId, setPredictedDataId] = useState("");
  const [predictedGpt, setPredictedDataGpt] = useState("");
  const [openModal, setOpenModal] = useState(false);
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [feedback, setFeedBack] = useState({
    rating: 0,
    ratingReason: "",
    confidenceLevel: "",
    suggestedNpk: "",
    AgroZone: "",
    Season: ""
  });
  const [message, setMessage] = useState("");
  const [severity, setSeverity] = useState("success");
  const [open, setOpen] = useState(false);

  const handleFileUpload = event => {
    const files = Array.from(event.target.files);
    setUploadedFiles(prevFiles => [...prevFiles, ...files]);
  };

  const handleRemoveFile = index => {
    setUploadedFiles(uploadedFiles.filter((_, i) => i !== index));
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_BASE_URL}/agri/latest/data`
        );
        if (response.status == 200) {
          setVal(data => ({
            ...data,
            nitrogen: response.data.data[0].nitrogen,
            phosphorus: response.data.data[0].phosphorus,
            potassium: response.data.data[0].potassium,
            temperature: response.data.data[0].temperature,
            humidity: response.data.data[0].humidity
          }));
        }
      } catch (err) {
        console.log(err);
      }
    };

    fetchData();

    // Optional: Polling every 10 seconds
    // const interval = setInterval(fetchData, 10000);

    // return () => clearInterval(interval); // Cleanup interval on unmount
  }, []);

  const [loadingApi1, setLoadingApi1] = useState(false);
  const [loadingApi2, setLoadingApi2] = useState(false);
  const [loadingApi3, setLoadingApi3] = useState(false);
  const [predictionshort, setpredictionshort] = useState(false);
  const handleSubmitFeedback = async () => {
    setLoadingApi3(true);
    // Prepare FormData
    const formData = new FormData();
    uploadedFiles.forEach(file => formData.append("files", file)); // Ensure backend supports multiple files
    // Append feedback data
    Object.keys(feedback).forEach(key => {
      formData.append(key, feedback[key]);
    });
    formData.append("prediction_id", predictedId);

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/fertilizer/recommendation/expert/feedback`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("userToken")}`, // Replace with your token source
            "Content-Type": "multipart/form-data"
          }
        }
      );
      if (response.data.message == "Prediction created successfully!") {
        setOpenModal(false);
        setMessage(response.data.message);
        setSeverity("success");
        setOpen(true);
      }

      console.log("Upload Success:", response.data);
    } catch (error) {
      setMessage("some problem occured, please try again");
      setSeverity("error");
      setOpen(true);
      console.error("Upload Error:", error);
    } finally {
      setLoadingApi3(false);
      setFeedBack({
        rating: 0,
        ratingReason: "",
        confidenceLevel: "",
        suggestedNpk: "",
        AgroZone: "",
        Season: ""
      });
    }
  };

  const [currPrompt, setLatestPrompt] = useState("");
  const [updatePrompt, setUpdatedPrompt] = useState("");
  const [updateMessage, setUpdatedMessage] = useState("");

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_BASE_URL}/get/latest/prompt`
        );

        if (response.data.status === "Success") {
          setLatestPrompt(response.data.prompt);
        }
      } catch (err) {
        console.log(err);
      }
    };

    fetchData();

    // Optional: Polling every 10 seconds
    // const interval = setInterval(fetchData, 10000);

    // return () => clearInterval(interval); // Cleanup interval on unmount
  }, [updateMessage]);

  const handleUpdate = async () => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/update/latest/prompt`,
        {
          prompt: currPrompt
        }
      );

      if (response.data.status === "Success") {
        setUpdatedMessage(response.data.message);
      }
    } catch (err) {
      console.log(err);
    }
  };

  // const handlePrediction = async () => {
  //   const response = await axios.post(
  //     `${process.env.REACT_APP_BASE_URL}/agri/fertilizer/recommendation`,
  //     {
  //       temperature: val.temperature,
  //       humidity: val.humidity,
  //       nitrogen: val.nitrogen,
  //       potassium: val.potassium,
  //       phosphorous: val.phosphorus,
  //       croptype: val.croptype,
  //       soiltype: val.soiltype,
  //       moisture: val.moisture,
  //     }
  //   );
  //   if (response.data.status == "success") {
  //     setPredictedData(response.data.data);
  //   }
  // };

  function formatRecommendation(jsonData) {
    if (!jsonData.response) {
      return "No recommendation data available.";
    }

    // Split response into sections based on numbered points (1., 2., 3.)
    const sections = jsonData.response.split(/\n\n(?=\d+\.)/);

    // Format each section into markdown-style text
    let formattedText = `### Optimized Recommendations\n\n`;

    sections.forEach(section => {
      formattedText +=
        section
          .replace(/\*\*(.*?)\*\*/g, "**$1**") // Keep bold formatting
          .replace(/-\s/g, "- ") // Normalize list formatting
          .replace(/\n\s+/g, "\n") + "\n\n"; // Remove unnecessary spaces
    });

    return formattedText.trim();
  }

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpen(false);
  };

  const handlePrediction = async () => {
    setOpenModal(true);
    try {
      setLoadingApi1(true);
      setLoadingApi2(true);
      // First API Call: Fertilizer Recommendation
      const api1Promise = axios
        .post(
          `${process.env.REACT_APP_BASE_URL}/agri/fertilizer/recommendation/id`,
          {
            temperature: val.temperature,
            humidity: val.humidity,
            nitrogen: val.nitrogen,
            potassium: val.potassium,
            phosphorous: val.phosphorus,
            croptype: val.croptype,
            soiltype: val.soiltype,
            moisture: val.moisture,
            modeltype: val.modeltype
          },
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("userToken")}`, // Replace with your token source
              "Content-Type": "application/json"
            }
          }
        )
        .then(response => {
          if (response.data.status === "success") {
            setPredictedDataId(response.data.id);
            setPredictedData(response.data.data); // UI updates immediately
          }
        })
        .catch(error => {
          console.error(
            "First API failed:",
            error.response && error.response.data
              ? error.response.data
              : error.message
          );
        })
        .finally(() => setLoadingApi1(false));

      // Second API Call: GPT-based Recommendation
      const api2Promise = axios
        .post(
          `${process.env.REACT_APP_BASE_URL}/agri/fertilizer/recommendation/gpt`,
          {
            temperature: val.temperature,
            humidity: val.humidity,
            nitrogen: val.nitrogen,
            potassium: val.potassium,
            phosphorus: val.phosphorus,
            crop_type: val.croptype,
            soil_type: val.soiltype,
            soil_moisture: val.moisture
          }
        )
        .then(response => {
          console.log(formatRecommendation(response.data));
          setPredictedDataGpt(response.data.response);
          console.log("Second API Data:", response.data.response);
        })
        .catch(error => {
          console.error(
            "Second API failed:",
            error.response && error.response.data
              ? error.response.data
              : error.message
          );
        })
        .finally(() => setLoadingApi2(false));

      // Run both APIs in parallel without blocking UI updates
      await Promise.allSettled([api1Promise, api2Promise]);
    } catch (error) {
      console.error("Unexpected error in API calls:", error);
    }
  };

  const fileInputRef = useRef(null);

  const handleChange = e => {
    setVal({ ...val, [e.target.name]: e.target.value });
  };

  const handleChangeFeedBack = (event, name) => {
    event.persist();
    setFeedBack(prev => ({
      ...prev,
      [name]: event.target.value
    }));
  };
  const [role, setRole] = useState(null);
// ✅ Move this to the top, before using `translations`

  useEffect(() => {
    const storedRole = localStorage.getItem('userRole');
    setRole(storedRole);
  }, []);

  const renderRoleView = () => {
    switch (role) {
      case 'Admin':
        return <AdminView />;
      case 'superAdmin':
        return <AdminView />;
      case 'user':
        return <UserView />;
      case 'Expert':
        return <ExpertView />;
      default:
        return <p className="text-red-500">Invalid role or role not set.</p>;
    }
  };
 


  if (!role) return <div className="text-center mt-10 text-gray-600">Loading...</div>;

  return (
    <>
          
    {renderRoleView()}

    </>
  );
};

export default recommendation;

